import { MessageCircle } from 'lucide-react'

import { Button } from '@/components/ui/button'

// Temporary address: replace it with the inbox that should receive feedback.
const FEEDBACK_EMAIL = 'contact@jumpdle.example'
const FEEDBACK_SUBJECT = 'Jumpdle — Suggestion ou bug'

const feedbackUrl = `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(FEEDBACK_SUBJECT)}`

export function FeedbackButton() {
  return (
    <Button
      asChild
      size="icon"
      className="fixed right-5 bottom-5 z-50 size-12 rounded-full shadow-lg sm:right-6 sm:bottom-6"
    >
      <a
        href={feedbackUrl}
        aria-label="Envoyer une suggestion ou signaler un bug"
        title="Suggestion ou bug"
      >
        <MessageCircle aria-hidden="true" className="size-5" />
      </a>
    </Button>
  )
}
